import { render, staticRenderFns } from "./AdminDashboard.vue?vue&type=template&id=2a0c9bc9&scoped=true&"
import script from "./AdminDashboard.vue?vue&type=script&lang=js&"
export * from "./AdminDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AdminDashboard.vue?vue&type=style&index=0&id=2a0c9bc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0c9bc9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a0c9bc9')) {
      api.createRecord('2a0c9bc9', component.options)
    } else {
      api.reload('2a0c9bc9', component.options)
    }
    module.hot.accept("./AdminDashboard.vue?vue&type=template&id=2a0c9bc9&scoped=true&", function () {
      api.rerender('2a0c9bc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/AdminDashboard.vue"
export default component.exports